import {OddsPreviewDomainModel} from "./odds-preview.domain-model";
import {OddsCellViewModel} from "./odds-cell/odds-cell.view-model";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {OddsCellDomainModel} from "./odds-cell/odds-cell.domain-model";
import {makeObservable,computed } from 'mobx';

export class OddsPreviewViewModel extends BaseViewModel {
  domainModel: OddsPreviewDomainModel;

  constructor(domainModel: OddsPreviewDomainModel) {
    super(domainModel);

    makeObservable(this);
  }

  @computed get cellsRates() {
    return this.domainModel?.cells?.map((cell:OddsCellDomainModel) => new OddsCellViewModel(cell));
  }
}
